// export default ProfessionalSummary;
import React, { useState, useEffect } from "react";
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import MicIcon from "@mui/icons-material/Mic";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import TextEditor from "../components/TextArea";
// import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import {
  generate_professional_summary,
  clearPS,
  saveJobAndSum,
  personal_information
} from "../../../Redux/ActionCreator";
import {
  Deepseek_generate_professional_summary
} from "../../../Redux/DeepseekAI/index"
import { ToastContainer, toast } from "react-toastify";
import PencilLoader from "../../common/LoaderModal/PencilLoader";
// import { saveIntoServerCache, getTwoFromServerCache, getAllResumeDetailsInCache, getOneFromServerCache } from "../../../utils/saveIntoCache";


const ProfessionalSummary = ({ nextStep, prevStep }) => {
  const dispatch = useDispatch();
  const [summary, setSummary] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [showHeading1, setShowHeading1] = useState(false);
  const [showHeading2, setShowHeading2] = useState(false);
  const [showHeading3, setShowHeading3] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);
  const prof_summary = useSelector((summary) => summary.summary);
  const combined_skills = useSelector(e => e.combine_skills);
  const Tech_skills = useSelector((e) => e.skills);
  const activity = useSelector((act) => act.activities); 
  const info = useSelector((info) => info.personal_info);
  let YOF = useSelector(e => e.yof);
  const secret = useSelector((prev) => prev.secret);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  const [ loading, setLoading ] = useState(false);
  const [showGeneratingModal, setShowGeneratingModal] = useState(false);

  useEffect(() => {
    if (prof_summary.summary !== null) {
      // prefill the summary into the summary textarea
      setSummary(prof_summary.summary);
      setLoading(false);
    }
  }, [prof_summary])

  // Speech Recognition Hook
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } =
    useSpeechRecognition();

  useEffect(() => {
    setSummary(transcript); // Update text editor with recognized speech
  }, [transcript]);

  useEffect(() => {
    const showHeading1Timeout = setTimeout(() => setShowHeading1(true), 4000);
    return () => clearTimeout(showHeading1Timeout);
  }, []);

  useEffect(() => {
    if (showHeading1) {
      const showHeading2Timeout = setTimeout(() => setShowHeading2(true), 4500);
      return () => clearTimeout(showHeading2Timeout);
    }
  }, [showHeading1]);

  useEffect(() => {
    if (showHeading2) {
      const showHeading3Timeout = setTimeout(() => setShowHeading3(true), 2500);
      return () => clearTimeout(showHeading3Timeout);
    }
  }, [showHeading2]);

  useEffect(() => {
    if (showHeading3) {
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 2500);
      return () => clearTimeout(showButtomBTNTimeout);
    }
  }, [showHeading3]);

  // Handle Microphone Start/Stop
  const handleMicClick = () => {
    if (!browserSupportsSpeechRecognition) {
      alert("Your browser does not support speech recognition.");
      return;
    }

    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      resetTranscript(); // Reset transcript before starting new speech
      SpeechRecognition.startListening({ continuous: true, language: flowLanguage == "English" ? "en-US" : "es-ES" });
    }
    setIsListening(!isListening);
  };

  useEffect(() => {
    if (prof_summary.summary !== null) {
      setSummary(prof_summary.summary);
    } else {
      // get from the server cache

    }
  }, [prof_summary])

  const handleGenerateSummary = () => {
    if (listening) {
      SpeechRecognition.stopListening();
    }
    setIsListening(!isListening);
    setShowGeneratingModal(true);
    dispatch(clearPS());
    const cred = {
      Experience: activity?.activities,
      Technical_skills: Tech_skills?.skills,
      Language: flowLanguage || "English", // Language,
      CvType: info.message?.JobInterests[0].value !== undefined ? info.message?.JobInterests[0].value : info.message?.JobInterests[0],
      summary: summary,
      type: "create professional summary"
    };
    // console.log("executing professional summary generating process");
    // dispatch(generate_professional_summary(cred));
    dispatch(generate_professional_summary(cred));
    setLoading(true);
    
    // Hide modal after a delay (simulate generation time)
    setTimeout(() => {
      setShowGeneratingModal(false);
    }, 3000);
  }

  /* Moving section */
  const handlePrev = () => {
      prevStep();
  }

  const handleNextCall = async () => {
      // handleNext(dispatch, firstName, lastName, nextStep);
      try {
          if (prof_summary?.summary !== null) {
              dispatch(saveJobAndSum(info.message?.JobInterests[0], prof_summary?.summary, YOF?.message || 0, secret.secret));
              let data = { ...info.message, summaryReviewed: true }
              dispatch(personal_information(data));
              nextStep();
          } else {
          setTimeout(() => {
              toast.error("At least one soft skills is required", {
                  position: toast.POSITION.TOP_RIGHT,
              });
          }, 50);
          }
      } catch (error) {
          throw error
      }
  }
  

  return (
    <>
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        
        {/* Tabs Section */}
        <div className="flex justify-center w-full">
          <div className="tabarea gap-x-0 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="3" current={false} label="Skills" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="4" current={false} label="Language" completed={true} />
            </div>
            <Tab num="5" current={false} label="Education" completed={true} />
            <Tab num="6" current={true} label="Professional Summary" completed={false} />
          </div>
        </div>

        {/* Title and Instructions with Typing Effect */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center text-2xl font-semibold mt-6 notranslate"
        >
          {flowLanguage == "Spanish" ? (
            <Typewriter key={flowLanguage} words={["Aquí tienes tu resumen profesional. Haz clic en 'Crear Resumen' para generar otro. Haz clic en 'Guardar' para continuar."]} loop={1} typeSpeed={40} />
          ) : (
            <Typewriter key={flowLanguage} words={["Here is your professional summary. Click 'Create Summary' to generate another one. Click 'Save' to continue."]} loop={1} typeSpeed={40} />
          )}
          
        </motion.h2>

        {showHeading1 && (
          <p className="text-center text-gray-600 mt-4 notranslate">
            {flowLanguage == "Spanish" ? (
              <Typewriter key={flowLanguage} words={["Utiliza el editor de texto enriquecido para dar formato limpio al texto de tu resumen. Haz clic en el micrófono para hablar en lugar de escribir."]} loop={1} typeSpeed={40} />
            ) : (
              <Typewriter key={flowLanguage} words={["Use the rich text editor to cleanly format text in your summary. Click on the microphone to speak instead."]} loop={1} typeSpeed={40} />
            )}
            {/* <Typewriter words={["Use the rich text editor to cleanly format text in your summary. Click on the microphone to speak instead."]} loop={1} typeSpeed={40} /> */}
          </p>
        )}

        {/* Rich Text Editor with Microphone Button */}
        {showHeading2 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mt-6 w-full relative"
          >
            <TextEditor
              className="h-56 w-full xl:w-full 2xl:w-full rounded-lg border border-radius border-indigo-400 border-opacity-30 focus:outline-none focus:border-2 focus:border-indigo-400 placeholder:text-[#B3B3B3] text-2xl font-normal notranslate"
              style={{ resize: "none" }}
              placeholder="Start typing or use the microphone..."
              value={summary}
              onChange={(value) => setSummary(value)}
              required
              notranslate
            />

            {/* Microphone Button */}
            <motion.button
              onClick={handleMicClick}
              className={`absolute top-[8%] right-7 p-1 rounded-full shadow-lg transition duration-300 
                ${listening ? "bg-red-500 hover:bg-red-600" : "bg-purple-500 hover:bg-purple-600"}`}
              animate={{
                scale: [1, 1.3, 1],
                y: [0, -15, 0],
                // rotate: [0, 40, -40, 0],
                filter: [
                  "drop-shadow(0px 0px 0px rgba(255,255,255,0))",
                  "drop-shadow(0px 0px 15px rgba(255,255,255,1))",
                  "drop-shadow(0px 0px 0px rgba(255,255,255,0))"
                ],
              }}
              transition={{
                duration: 0.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <MicIcon className="text-white text-xxl" />
            </motion.button>
          </motion.div>
        )}

        {/* Create Summary Button */}
        {showHeading3 && (
          <motion.div
            whileTap={{ scale: 0.95 }}
            className="flex justify-center my-4"
          >
            <button
              className="bg-gradient-to-r max-w-max from-[#FF6633] to-[#5843BD] text-white font-medium py-3 px-[20px] rounded-[50px] shadow-md hover:from-[#5843BD] hover:to-[#FF6633] transition-colors duration-300 flex items-center justify-center text-xl notranslate"
              onClick={handleGenerateSummary}
              key={flowLanguage}
            >
              {flowLanguage === "Spanish" ? (
                "CREAR RESUMEN"
              ) : (
                "CREATE SUMMARY"
              )}
              <span className="ml-2">
                <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1740040104/Website%20images/moil-white-logo_fndycf.png" alt="Moil white logo" />
              </span>
            </button>
          </motion.div>
        )}

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4  vsm:px-6 px-8 rounded-md"
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4 px-6 rounded-md"
                  >
                    <span className="notranslate" key={flowLanguage}>
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                    </span>
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>

      </div>
      
      {/* Generating Summary Modal */}
      {showGeneratingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-3xl p-8 max-w-md w-full mx-4 text-center">
            <div className="mb-6 flex justify-center">
              <PencilLoader />
            </div>
            <h3 className="text-xl font-semibold text-[#5843BD] mb-4 notranslate" key={flowLanguage}>
              {flowLanguage === "Spanish" ? (
                "Generando tu resumen profesional..."
              ) : (
                "Generating your professional summary..."
              )}
            </h3>
            <p className="text-gray-600 text-base notranslate" key={flowLanguage}>
              {flowLanguage === "Spanish" ? (
                "La IA de Moil está creando un resumen personalizado basado en tu experiencia y habilidades."
              ) : (
                "Moil AI is creating a personalized summary based on your experience and skills."
              )}
            </p>
          </div>
        </div>
      )}
    </div>
    <ToastContainer />
    </>
  );
};

export default ProfessionalSummary;
